import React from 'react';
import { css } from '../styled-system/css/index';

const wrapperStyle = css({
  mt: '40px',
  borderTop: '1px solid #e5e7eb',
  bg: '#ffffff',
});

const innerStyle = css({
  maxW: '1200px',
  m: '0 auto',
  p: '18px 20px',
  color: '#6b7280',
  fontSize: '0.95rem',
});

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className={wrapperStyle}>
      <div className={innerStyle}>
        © {year} Website by Bobs Smart Tech Solutions | All Rights Reserved | Want a website like this?{' '}
        <a href="https://bobssmarttechsolutions.com" target="_blank" rel="noreferrer">Click here</a>
      </div>
    </footer>
  );
};

export default Footer;
